import { InferType, object, string } from 'yup'

export interface IConfigurableBuilderOptionsSchema {
  outboundEdiMapperConnectionConfigId: string
}

export const ConfigurableBuilderOptionsSchema = object<IConfigurableBuilderOptionsSchema>({
  outboundEdiMapperConnectionConfigId: string().required('Config ID is required'),
})

export type TConfigurableBuilderSchema = InferType<typeof ConfigurableBuilderOptionsSchema>
